import isObject from 'lodash/isObject'
import merge from 'lodash/merge'
import reduce from 'lodash/reduce'

type FlattenedObject = { [key: string]: string }

export const flattenKeys = <T>(obj: T, path: string[] = []): FlattenedObject =>
  !isObject(obj)
    ? { [path.join('.')]: obj }
    : reduce(obj, (cum, next, key) => merge(cum, flattenKeys(next, [...path, key])), {})

export const unflattenKeys = (obj: FlattenedObject): {} =>
  Object.keys(obj).reduce((res, key) => {
    try {
      key.split('.').reduce((acc: { [key: string]: unknown }, e: string, index, keys) => {
        return (
          acc?.[e] ||
          (acc[e] = isNaN(Number(keys[index + 1]))
            ? keys.length - 1 === index
              ? obj?.[key]
              : {}
            : [])
        )
      }, res)
    } catch (error) {
      console.error('unflattenKeys error:', error)
    }
    return res
  }, {})
